module.exports = __webpack_public_path__ + "img/23exp.983dcdaf.jpg";